export enum QuizStatus {
  SUBMITTED = "submitted",
  AUTO_SUBMITTED = "auto submitted",
  NOT_SUBMITTED = "not submitted",
  PENDING = "pending",
  IN_PROGRESS = "in progress",
  ALL = "all",
  Complete ='complete'
}